export const STICK_MAX_RADIUS_PX = 60;
export const STICK_DEAD_ZONE_PX = 10;

export interface Thumbstick {
  readonly baseX: number;
  readonly baseY: number;
  readonly knobX: number;
  readonly knobY: number;
  readonly angle: number;
  readonly magnitude: number;
}

export function pressStick(x: number, y: number): Thumbstick {
  return { baseX: x, baseY: y, knobX: x, knobY: y, angle: 0, magnitude: 0 };
}

export function dragStick(
  baseX: number,
  baseY: number,
  touchX: number,
  touchY: number,
): Thumbstick {
  const dx = touchX - baseX;
  const dy = touchY - baseY;
  const distance = Math.hypot(dx, dy);

  if (distance <= STICK_DEAD_ZONE_PX) {
    return { baseX, baseY, knobX: touchX, knobY: touchY, angle: 0, magnitude: 0 };
  }

  const angle = Math.atan2(dy, dx);

  if (distance <= STICK_MAX_RADIUS_PX) {
    const magnitude = (distance - STICK_DEAD_ZONE_PX) / (STICK_MAX_RADIUS_PX - STICK_DEAD_ZONE_PX);
    return { baseX, baseY, knobX: touchX, knobY: touchY, angle, magnitude };
  }

  return {
    baseX: touchX - Math.cos(angle) * STICK_MAX_RADIUS_PX,
    baseY: touchY - Math.sin(angle) * STICK_MAX_RADIUS_PX,
    knobX: touchX,
    knobY: touchY,
    angle,
    magnitude: 1,
  };
}
